import commonHelper from '@/app/utility/common.helper.utility';
import appStrings from '@/app/utility/string.utility';
import { required, minLength } from 'vuelidate/lib/validators';
import backgroundVerification from '../partyDetails/backgroundVerification';
// import store from '../../../../../store';

export default {
  name: 'addPartyOnBoarding',
  components: {
    backgroundVerification
  },
  props: ['partyDetails', 'userId'],
  validations: {
    name: { required },
    panNumber: { minLength: minLength(10) },
    // templateType: {
    //   text: {
    //     required
    //   }
    // },
    email:{required},
    contactNumber:{required}
  },
  data() {
    return {
      unsubscribe: null,
      loader: false,
      showAlert: false,
      isSuccess: false,
      responseMsg: '',
      editMode: false,
      reqId: 0,
      name: null,
      email: null,
      contactNumber: null,
      panNumber: null,
      panNotAvailable: false,
      templateType: { value: null, text: null },
      internalContactName: null,
      internalContactEmail: null,
      internalContactNumber: null,
      approvalStatus: 'DRAFT',
      showValueSetModal: false,
      employeeId: this.$store.state.auth.userDtl.employee_id,
      supplierData: [
        {
          serial_no: null,
          check_point: null,
          scale: null,
          actual_score: null,
          remarks: null
        }
      ],
      supplierFields: [
        {
          key: 's_no',
          label: 'S. No',
          stickyColumn: true
        },
        {
          key: 'check_point'
        },
        {
          key: 'scale',
          stickyColumn: true
        },
        {
          key: 'actual_score'
        },
        {
          key: 'remarks'
        }
      ],
      totalScore: null,
      rating: null,
      totalAmount: null,
      supplierName: null,
      panVerifyDetails: {
        category: null,
        client_id: null,
        full_name: null,
        pan_number: null
      },
      panNotApplicableFlag: "panApplicable",
      eventId: null
    };
  },
  mounted() {
    if (this.partyDetails) {
      this.getPartyOnBoardingDetailsById();
    } else {
      this.editMode = true;
      this.getInternalContactDetails(this.employeeId);
    }
    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'shared/setActionName') {
        const actionName = state.shared.actionName;
        if (actionName === 'save' && this.editMode) {
          this.saveNewFunction();
        }
        if (actionName === 'update') {
          this.editMode = true;
        }
      }
    });
    // this.setDefaultEvaluationTemplate()
  },
  methods: {
    getInternalContactDetails(employeeId) {
      this.loader = true;
      this.$store
        .dispatch('intWorkflow/getInternalContactDetails', employeeId)
        .then(resp => {
          this.loader = false;
          if (resp.status === 200) {
            const result = resp.data.data;
            this.internalContactName = result.employee_name;
            this.internalContactEmail = result.official_email_id;
            this.internalContactNumber = result.mobile;
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    getPartyOnBoardingDetailsById() {
      const payload = {
        party_req_id: this.reqId,
        user_id: this.userId
      };
      this.loader = true;
      this.$store
        .dispatch('intWorkflow/getPartyOnBoardingDetailsById', payload)
        .then(resp => {
          this.loader = false;
          if (resp.status === 200) {
            const result = resp.data.data;
            this.reqId = result.req_id;
            this.name = result.party_name;
            this.email = result.email;
            this.contactNumber = result.mob;
            this.panNumber = result.pan;
            this.panNotAvailable = result.pan_not_avl;
            this.internalContactName = result.int_contact_name;
            this.internalContactEmail = result.int_contact_email;
            this.internalContactNumber = result.int_contact_mob;
            this.approvalStatus = result.approval_status;
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    isMobileValid(payload) {
      if (payload.mob) {
        if (payload.mob.length == 10) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    },
    saveNewFunction() {
      if (this.panNumber) {
        if (commonHelper.isValidPanNumber(this.panNumber)) {
          this.panAadhaarVerify();
          // this.checkPanVerify();
          // this.addEditPartyOnBoarding()
        } else {
          this.panNumber = null;
        }
      } else {
        this.addEditPartyOnBoarding();
      }
    },
    panAadhaarVerify() {
      const payload = {
        id_number: this.panNumber
      };
      this.loader = true;
      this.$store
        .dispatch('partyOnboardingVatika/panAadhaarVerify', payload)
        .then(response => {
          this.loader = false;
          if (response.status === 200) {
            const result = response.data.data.data;
            if (result.status === 'invalid') {
              this.showAlert = true;
              this.isSuccess = false;
              this.responseMsg = response.data.data.message;
            } else if (result.status === 'valid') {
              this.panVerifyDetails = {
                category: result.category,
                client_id: result.client_id,
                full_name: result.full_name,
                pan_number: result.pan_number
              };
              if (this.panNumber.charAt(3) === 'P') {
                if (result.aadhaar_linked) {
                  // this.isVendorExist();
                  this.addEditPartyOnBoarding()
                } else {
                  alert('PAN is Not Verified With Aadhaar');
                }
              } else {
                this.addEditPartyOnBoarding();
              }
            } else {
              this.showAlert = true;
              this.isSuccess = false;
              this.responseMsg = response.data.data;
            }
          } else {
            this.showAlert = true;
            this.isSuccess = false;
            this.responseMsg = response.response.data.message;
          }
        })
        .catch(() => {
          this.loader = false;
          this.isSuccess = false;
          this.responseMsg = appStrings.autoFailedMsg;
        });
    },
    getEventId() {
      const payload = {
        event_name: 'Party Onboarding'
      };
      this.loader = true;
      this.$store
        .dispatch('partyOnboardingVatika/getEventId', payload)
        .then(response => {
          this.loader = false;
          this.showAlert = true;
          if (response.status === 200) {
            this.eventId = response.data.data.Event_Id;
            this.getHistory();
          } else {
            this.isSuccess = false;
            this.responseMsg = response.response.data.message;
          }
        })
        .catch(() => {
          this.loader = false;
          this.showAlert = true;
          this.isSuccess = false;
          this.responseMsg = appStrings.autoFailedMsg;
        });
    },
    // checkPanVerify() {
    //   const payload = {
    //     id_number: this.panNumber
    //   };
    //   this.loader = true;
    //   this.$store
    //     .dispatch('intWorkflow/checkPanVerify', payload)
    //     .then(response => {
    //       this.loader = false;
    //       if (response.status === 200) {
    //         const result = response.data.data;
    //         if (result == 'Invalid PAN') {
    //           this.showAlert = true;
    //           this.isSuccess = false;
    //           this.responseMsg = response.data.data;
    //         } else if (result.message_code == 'success') {
    //           this.panVerifyDetails = result.data;
    //           if (this.panNumber.charAt(3) === 'P') {
    //             this.panAadhaarVerify();
    //           } else {
    //             this.isVendorExist();
    //             // this.addEditPartyOnBoarding()
    //           }
    //         } else {
    //           this.showAlert = true;
    //           this.isSuccess = false;
    //           this.responseMsg = response.data.data;
    //       // this.isVendorExist();   }
    //       } else {
    //         this.showAlert = true;
    //         this.isSuccess = false;
    //         this.responseMsg = response.response.data.message;
    //       }
    //     })
    //     .catch(() => {
    //       this.loader = false;
    //       this.isSuccess = false;
    //       this.responseMsg = appStrings.autoFailedMsg;
    //     });
    // },
    // panAadhaarVerify() {
    //   const payload = {
    //     pan: this.panNumber
    //   };
    //   this.loader = true;
    //   this.$store
    //     .dispatch('intWorkflow/panAadhaarVerify', payload)
    //     .then(response => {
    //       this.loader = false;
    //       if (response.status === 200) {
    //         const result = response.data.data;
    //         if (result.message_code === 'success' && result.data.linking_status) {
    //           this.isVendorExist();
    //           // this.addEditPartyOnBoarding();
    //         } else {
    //           alert('PAN is Not Verified With Aadhaar');
    //         }
    //       } else {
    //         this.showAlert = true;
    //         this.isSuccess = false;
    //         this.responseMsg = response.response.data.message;
    //       }
    //     })
    //     .catch(() => {
    //       this.loader = false;
    //       this.isSuccess = false;
    //       this.responseMsg = appStrings.autoFailedMsg;
    //     });
    // },
    // panAadhaarVerify() {
    //   const payload = {
    //     pan_number: this.panNumber,
    //     consent: "Y"
    //   };
    //   this.loader = true;
    //   this.$store
    //     .dispatch('intWorkflow/panAadhaarVerify', payload)
    //     .then(response => {
    //       this.loader = false;
    //       if (response.status === 200) {
    //         const result = response.data.data;
    //         if (result.code === '1016') {
    //           this.isVendorExist();
    //         } else if(result.code === '1004') {
    //           alert('PAN does not exist');
    //         } else if(result.code === '1006') {
    //           alert('Aadhar is not linked');
    //         }
    //       } else if(response.status === 400) { 
    //         if(response.data.data.code === 'INVALID_INDIVIDUAL_PAN') {
    //           alert('Invalid Individual PAN Number');
    //         } else if(response.data.data.code === 'BAD_REQUEST') {
    //           alert('PAN Number is required');
    //         } 
    //       }
    //     })
    //     .catch(() => {
    //       this.loader = false;
    //       this.isSuccess = false;
    //       this.responseMsg = appStrings.autoFailedMsg;
    //     });
    // },
    isVendorExist() {
      const payload = {
        REG_DETAILS: {
          REG_DETAILS_ITEM: [
            {
              REG_TYPE: 'PAN',
              REG_NUMBER: this.panNumber
            }
          ]
        }
      };
      this.loader = true;
      this.$store
        .dispatch('intWorkflow/isVendorExist', payload)
        .then(resp => {
          this.loader = false;
          if (resp.status === 200) {
            const result = resp.data.data.data.OutputParameters[0];
            if (result.RETURN_CODE === 'N') {
              this.addEditPartyOnBoarding();
            } else if (result.RETURN_CODE === 'S') {
              if (this.panNumber.charAt(3) === 'P') {
                const promt = confirm(
                  'PAN Number already exist with another vendor\n' +
                    'Do you want to continue ?'
                );
                if (promt) {
                  this.addEditPartyOnBoarding();
                }
              } else {
                this.showAlert = true;
                this.isSuccess = false;
                this.responseMsg = `PAN Number already exist with Vendor Name: ${result.RETURN_MESSAGE}`;
              }
            }
          } else {
            this.showAlert = true;
            this.isSuccess = false;
            this.responseMsg = resp.response.data.message;
          }
        })
        .catch(() => {
          this.loader = false;
          this.showAlert = true;
          this.isSuccess = false;
          this.responseMsg = appStrings.autoFailedMsg;
        });
    },
    addEditPartyOnBoarding() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.contactNumber = this.contactNumber
          ? this.contactNumber.replace(/[^0-9]/g, '')
          : this.contactNumber;
          this.email = this.email
          ? this.email.replace(/\s+/g, '')
          : this.email;
        if (this.email || this.contactNumber) {
          const payload = {
            req_id: this.reqId,
            party_name: this.name,
            email: this.email ? this.email.trim() : this.email,
            mob: this.contactNumber ? this.contactNumber : null,
            pan: this.panNumber,
            // template_type_code: this.templateType.value,
            pan_not_avl: this.panNotApplicableFlag === 'panNotApplicable' ? true : false,
            int_contact_name: this.internalContactName,
            int_contact_email: this.internalContactEmail,
            int_contact_mob: this.internalContactNumber,
            bgvc_applicable_flag: this.bgvcConsentFlag ? true : false
          };
          if (this.isMobileValid(payload)) {
            this.loader = true;
            this.$store
              .dispatch('intWorkflow/addEditPartyOnBoarding', payload)
              .then(response => {
                this.loader = false;
                this.showAlert = true;
                if (response.status === 201) {
                  this.editMode = false;
                  this.isSuccess = true;
                  this.responseMsg = response.data.message;
                  this.reqId = response.data.data.req_id;
                  this.partyRequestId = response.data.data.req_id;
                  // this.partyData = {
                  //   party_name: response.data.data.party_name,
                  //   email: response.data.data.email,
                  //   mob: response.data.data.mob,
                  //   pan: response.data.data.pan,
                  //   req_id: response.data.data.req_id
                  // };
                  // this.getBackgroundVerificationData();
                  this.getEventId()
                  // this.getHistory(this.reqId);
                  this.$emit('updateList');
                  this.addPanVerifyDetails();
                } else {
                  this.isSuccess = false;
                  this.responseMsg = response.response.data.message;
                }
              })
              .catch(() => {
                this.loader = false;
                this.showAlert = true;
                this.isSuccess = false;
                this.responseMsg = appStrings.autoFailedMsg;
              });
          } else {
            alert('Please Enter Correct Mobile Number.');
          }
        } else {
          alert('Please Enter Email-Id or Mobile Number.');
        }
      }
    },
    addPanVerifyDetails() {
      const payload = {
        party_req_id: this.reqId,
        pan_ver_id: 0,
        category: this.panVerifyDetails.category,
        client_id: this.panVerifyDetails.client_id,
        full_name: this.panVerifyDetails.full_name,
        pan_number: this.panVerifyDetails.pan_number
      };
      this.loader = true;
      this.$store
        .dispatch('intWorkflow/addPanVerifyDetails', payload)
        .then(response => {
          this.loader = false;
          if (response.status === 201) {
            this.getPanVerifyDetailsById();
          } else {
            this.showAlert = true;
            this.isSuccess = false;
            this.responseMsg = response.response.data.message;
          }
        })
        .catch(() => {
          this.loader = false;
          this.showAlert = true;
          this.isSuccess = false;
          this.responseMsg = appStrings.autoFailedMsg;
        });
    },
    getPanVerifyDetailsById() {
      const payload = {
        party_req_id: this.reqId
      };
      this.loader = true;
      this.$store
        .dispatch('intWorkflow/getPanVerifyDetailsById', payload)
        .then(resp => {
          this.loader = false;
          if (resp.status === 200) {
            const result = resp.data.data;
            this.panVerifyDetails = result;
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    getHistory() {
      this.loader = true;
      const payload = {
        event_id: this.eventId,
        record_id: this.reqId
      };
      this.loader = true;
      this.$store
        .dispatch('intWorkflow/processWorkflow', payload)
        .then(response => {
          this.loader = false;
          if (response.status === 200) {
            const historyList = response.data.data;
            if (historyList.length) {
              this.sendEmailVendor(this.reqId);
            }
          } else {
            alert(response.response.data.message);
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    sendEmailVendor(reqId) {
      const payload = {
        party_req_id: reqId
      };
      this.loader = true;
      this.$store
        .dispatch('intWorkflow/sendEmailVendor', payload)
        .then(response => {
          this.loader = false;
          this.showAlert = true;
          if (response.status === 200) {
            this.editMode = false;
            this.isSuccess = true;
            this.responseMsg = response.data.message;
          } else {
            this.isSuccess = false;
            this.responseMsg = response.response.data.message;
          }
        })
        .catch(() => {
          this.loader = false;
          this.showAlert = true;
          this.isSuccess = false;
          this.responseMsg = appStrings.autoFailedMsg;
        });
    },
    upperCaseFunction(panNumber) {
      this.panNumber = panNumber.toUpperCase();
    },
    openValueSetModal(vsetCode, index) {
      this.vsetCode = vsetCode;
      this.specIndex = index;
      this.reasonIndex = index;
      this.referenceIndex = index;
      this.showValueSetModal = true;
      this.setTimeVsetCode = setTimeout(() => {
        const vSetData = {
          valueSetName: vsetCode,
          multiFlag: null
        };
        this.eventBus.$emit('valueSetCode', vSetData);
      }, 0);
    },
    selectedvalueSet(item) {
      if (this.vsetCode === appStrings.VALUESETTYPE.Select_Employee) {
        this.internalContactName = item.value_code;
        this.internalContactEmail = item.official_email_id;
        this.internalContactNumber = item.mobile.slice(2);
      } else if (
        this.vsetCode === appStrings.VALUESETTYPE.PARTY_REQ_TEMPLATE_TYPE
      ) {
        this.templateType.text = item.value_meaning;
        this.templateType.value = item.value_code;
      } else if(this.vsetCode === appStrings.VALUESETTYPE.PARTY_ON_BOARD_REASON_VSET) {
        this.reasonData[this.reasonIndex].reason_meaning=null
        let count=0;
        for(let i of this.reasonData) {
           if(i.reason === item.value_meaning) {
            count=count+1;
           }
        }
        if(count>0) {
          alert('Already exist');
          this.reasonData[this.reasonIndex].reason = null;
          this.reasonData.pop();
        } else {
            this.reasonData[this.reasonIndex].reason = item.value_meaning;
            if(item.value_meaning !== 'OTHER'){
              this.reasonData[this.reasonIndex].reason_meaning = item.value_meaning;
            }
               
        }
        
      } else if(this.vsetCode === appStrings.VALUESETTYPE.PARTY_ONBOARDING_REFERENCE) {
        let count=0;
        for(let i of this.referenceData) {
           if(i.reference === item.value_meaning) {
            count=count+1;
           }
        }
        if(count>0) {
          alert('Already exist');
          this.referenceData[this.referenceIndex].reference = null;
        } else {
          this.referenceData[this.referenceIndex].reference = item.value_meaning;
        }        
      } else if(this.vsetCode === appStrings.VALUESETTYPE.ALL_EMPLOYEE_VSET) {
        let count=0;
        for(let i of this.referenceData) {
           if(i.reference_data === item.user_email) {
            count=count+1;
           }
        }
        if(count>0) {
          alert('Already exist');
          this.referenceData[this.referenceIndex].reference_data = null;
        } else {
          this.referenceData[this.referenceIndex].reference_data = item.user_email;
        }
      }
    },
    closeValueSetModal() {
      this.showValueSetModal = false;
    },
    clearVsetValues(vsetName) {
      if (vsetName === this.internalContactName) {
        this.internalContactName = null;
        this.internalContactEmail = null;
        this.internalContactNumber = null;
      } else if (vsetName === this.templateType.value) {
        this.templateType.text = null;
        this.templateType.value = null;
      }
    },
    checkUncheckPanNotAvailable() {
      if(this.panNotApplicableFlag === 'panNotApplicable') {
       this.panNumber = null;
      }
    },
    //  setDefaultEvaluationTemplate() {
    //       const evaluationTemplate = commonHelper.getValuesetData(
    //         appStrings.VALUESETTYPE.PARTY_REQ_TEMPLATE_TYPE,
    //         store.state.shared.responsibilityId
    //       );
    //       evaluationTemplate.then(key=>{
    //         if(key.length==1){
    //           this.templateType.text = key[0].value_meaning;
    //           this.templateType.value = key[0].value_code;
    //         }
    //       })
    //     },
  },
  beforeDestroy() {
    this.unsubscribe();
  }
};
